/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
import { url } from '../../../../utils/urls';
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui';
import TriviaPollsHeader from './triviapollsheader/triviapollsheader';
// content
// styles
import injectSheet from "react-jss";
import styles from './configuration_styles';


/* ========== ~~~~~~~~~~ TRIVIA & POLLS CONFIG PAGE ~~~~~~~~~~ ========== */
const TriviaPollsConfigPage = injectSheet(styles)((props) => {

  return (
    <Page name={'triviapollsconfigpage'} klass={`${props.classes.triviapollsconfigpage}`}>
      <TriviaPollsHeader />
      <InContentMessage />
      <iframe title={'Embed Config'} src={`https://publisher.${url.baseURL}/dashboard/embeds`} />
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TriviaPollsConfigPage 